import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {PortalDocumentResponse} from '../_model/response/PortalDocumentResponse';
import {FileNameData} from '../_model/FileNameData';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  iconList = [
    'accessibility',
    'accessible',
    'alarm_on',
    '3d_rotation',
    'alarm'
  ];
  private ANNOUNCEMENT_IMG_SUBFOLDER = 'announcements/';
  private ABOUT_IMG_SUBFOLDER = 'about/';
  private PARTNER_IMG_SUBFOLDER = 'partners/';
  private PROJECT_IMG_SUBFOLDER = 'projects/';
  private SERVICE_IMG_SUBFOLDER = 'services/';
  private SERVICE_DETAIL_IMG_SUBFOLDER = 'services/details/';
  private fileStorageRootPath = environment.fileUploadPath;

  constructor() {
  }

  getAnnouncementImgPath(): string {
    return this.fileStorageRootPath + this.ANNOUNCEMENT_IMG_SUBFOLDER;
  }

  getAboutImgPath(): string {
    return this.fileStorageRootPath + this.ABOUT_IMG_SUBFOLDER;
  }

  getPartnersImgPath(): string {
    return this.fileStorageRootPath + this.PARTNER_IMG_SUBFOLDER;
  }

  getProjectsImgPath(): string {
    return this.fileStorageRootPath + this.PROJECT_IMG_SUBFOLDER;
  }

  getServicesImgPath(): string {
    return this.fileStorageRootPath + this.SERVICE_IMG_SUBFOLDER;
  }

  getServiceDetailsImgPath(): string {
    return this.fileStorageRootPath + this.SERVICE_DETAIL_IMG_SUBFOLDER;
  }

  public toTurkishLowerCase(word: string) {
      let result = word;
      const letters = { İ: 'i', I: 'ı', Ş: 'ş', Ğ: 'ğ', Ü: 'ü', Ö: 'ö', Ç: 'ç' };
      result = result.replace(/(([İIŞĞÜÇÖ]))/g, letter => letters[letter]);
      return result.toLowerCase();
  }

  public toTurkishUpperCase(word: string) {
      let result = word;
      const letters = { i: 'İ', ş: 'Ş', ğ: 'Ğ', ü: 'Ü', ö: 'Ö', ç: 'Ç', ı: 'I' };
      result = result.replace(/(([iışğüçö]))/g, letter => letters[letter]);
      return result.toUpperCase();
  }

}
